let storeContent = utils.generateStore({
	notifications: [],
	selectedNotification: {},
	showNotification: false,
});

export default {
	state() {
		return { ...storeContent.state };
	},
	getters: {
		...storeContent.getters,
	},
	mutations: {
		...storeContent.mutations,
	},
	actions: {
		closeModal(ctx) {
			ctx.commit('showNotification', false);
		},
		openModal(ctx, notification) {
			ctx.commit('selectedNotification', notification);
			ctx.commit('showNotification', true);
		},
		async fetchNotifications(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'notification',
						action: 'get',
						data: {},
					},
					'/client',
				);

				ctx.commit('notifications', res.result.client_notification);
			} catch (err) {
				throw err;
			}
		},
		async fetchData(ctx) {
			try {
				await ctx.dispatch('fetchNotifications');
				Event.$emit('loader:show', false);
			} catch (err) {
				throw err;
			}
		},
	},
};
